import React from "react";
import Decentraliced from "../assests/home/decentralization.jpeg";
import NewHomie from "../wallet_connect/NewHomie";

const HomePage = () => {
  return (
    <div className="mx-auto">
      <div className="py-14">
        <div className="block md:flex justify-between">
          <div className="mt-16 md:mt-44 md:ml-10 w-full text-center">
            <div className="text-4xl font-extrabold md:text-6xl md:font-extrabold ">
              Decentralized
            </div>
            <div className="text-3xl font-bold md:text-5xl md:font-bold text-blue-800 pt-2 md:pl-3">
              Platform Wallet
            </div>
          </div>
          <img src={Decentraliced} alt="logo" className="" />
        </div>
        <div className="px-4 md:px-24 py-12">
          <div className="text-4xl font-extrabold md:text-6xl md:font-extrabold text-blue-800 text-center pb-5">
            Our Services
          </div>
          <div className="text-lg md:text-2xl font-bold text-center">
            Dapp Walletnode is a decentralized protocol. dConnect create an
            innovative open-source software ecosystem that is both secure and
            resilient. And it allows developers to create new online tools, many
            of which have the interest of global business markets. Validation of
            wallet will be completed below as follows
          </div>
        </div>
      </div>
      <div className="mt-11">
        <NewHomie />
      </div>
    </div>
  );
};

export default HomePage;
